import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WidgetSimpleRadioButtonPreviewV0 } from './models/widget-simple-radio-button-preview-v0';
import { IoniconsFilled } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-simple-radiobutton-v0-preview',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf='noData; then NODATA; else DATA'></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <div class='pt-widget-simple-radiobutton-preview-v0'>
          <pt-icon class='widget-icon-preview-color' [key]='IconCheck'></pt-icon>
          <span>{{ previewData.label }}</span>
          <pt-w-help [help]='previewData?.help'></pt-w-help>
        </div>
      </ng-template>
    </ng-template>
  `,
  styles: [`
    .pt-widget-simple-radiobutton-preview-v0 {
      display: flex;
      padding: 0 2px;
    }

    .pt-widget-simple-radiobutton-preview-v0 span {
      margin-top: 2px;
    }
  `]
})
export class WidgetSimpleRadiobuttonV0PreviewComponent implements OnChanges {

  @Input() noDataLabel?: string;
  @Input() previewData: WidgetSimpleRadioButtonPreviewV0;
  @Input() loading: boolean;

  noData = true;
  IconCheck = IoniconsFilled.radiobutton;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewData) {
      this.noData = !this.previewData;
    }
  }
}
